import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  meta: {},
  assignment: null
}

export default createCrudModule({
  client: api.client,
  resource: 'assets',
  urlRoot: '/assets',
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  onFetchSingleSuccess: (state, { data, included }) => {
    state.assignment = _.find(included, i => i.id === data.relationships.assignment.data.id && i.type === 'asset_event');
  },
  state
});